import Cookies from 'universal-cookie';
import { v4 as uuid } from 'uuid';
import { getDomain } from './common';
export var TOURLANE_ID_COOKIE_NAME = 'tourlane_id';
export var VISIT_ID_COOKIE_NAME = 'visit_id';
export var CHANNEL_COOKIE_NAME = 'channel';
var TRACKING_COOKIE_TTL = 100 * 365 * 24 * 60 * 60 * 1000; // 100 years in milliseconds

export var setupTourlaneCookies = function setupTourlaneCookies() {
  var cookies = new Cookies();

  var _cookies$getAll = cookies.getAll(),
      tourlaneId = _cookies$getAll[TOURLANE_ID_COOKIE_NAME],
      visitId = _cookies$getAll[VISIT_ID_COOKIE_NAME];

  var domain = getDomain(); // This is a browser identifying cookie..

  if (!tourlaneId) {
    tourlaneId = uuid();
    cookies.set(TOURLANE_ID_COOKIE_NAME, tourlaneId, {
      path: '/',
      domain: domain,
      maxAge: TRACKING_COOKIE_TTL
    });
  } // This is the session cookie


  if (!visitId) {
    visitId = uuid();
    cookies.set(VISIT_ID_COOKIE_NAME, visitId, {
      path: '/',
      domain: domain
    });
  }
};